import { useCurrency } from "@/core/composables/useCurrency";
import { useThemeContext } from "@/core/composables/useThemeContext";
import { Logger } from "@/core/utilities";
import { BRL_CURRENCY_CODE, BRL_REPLACEMENT_CURRENCY_CODE, isBrlCurrencyDisabled } from "@/core/utilities/brlCurrency";

/**
 * BRL carts and contact preferences are converted server-side (mergeCart at sign-in and the
 * BRL Currency Migration job), so app startup only normalizes the browser's stored preference.
 * It returns `true` when a stored BRL preference was replaced, so the caller can convert the signed-in user's carts once.
 */
export const useBrlCurrencyMigration = () => {
  const { themeContext } = useThemeContext();
  const { savedCurrencyCode, saveCurrencyCode } = useCurrency();

  const migrateStoredBrlCurrency = (): boolean => {
    if (!isBrlCurrencyDisabled(themeContext.value.storeSettings.modules)) {
      return false;
    }

    let replacementAttempted = false;

    try {
      if (savedCurrencyCode.value === BRL_CURRENCY_CODE || localStorage.getItem("currency") === BRL_CURRENCY_CODE) {
        replacementAttempted = true;
        saveCurrencyCode(BRL_REPLACEMENT_CURRENCY_CODE, false);
        return true;
      }
    } catch (error) {
      Logger.error("Failed to migrate stored BRL currency during app startup", error);
      // saveCurrencyCode sets the session ref before writing localStorage, so the app may already run in USD.
      return replacementAttempted && savedCurrencyCode.value === BRL_REPLACEMENT_CURRENCY_CODE;
    }

    return false;
  };

  return { migrateStoredBrlCurrency };
};
